module.exports = __webpack_public_path__ + "static/img/1.b989d00.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/eng/1.png
// module id = jVWN
// module chunks = 0